import { TLMDStorage } from '../storage/storage'
import  * as CryptoJS  from 'crypto-js'
import { Digester, XHROptions } from '../xhr/xhr'

export const getKey = ( a:string, t:string ): string => {
    let v, k, w, b, c, j, u, h, r, p, d, g, e, o, m, s, l, f, n, q;
    v = 15;
    k = (parseInt(a[v], 16) % 2);
    w = Math.pow(32, k) - (1 - k);
    b = a.slice(w, w + 32);
    c = 16 * ((3 + k) % 4);
    j = a.slice(c, c + 16);
    u = parseInt(j[10 + k], 16);
    c = 16 * (u % 4);
    h = a.slice(c, c + 16);
    r = parseInt(j[(13 + u) % 16], 16);
    p = parseInt(h[r], 16);
    d = parseInt(j[(7 + r) % 16], 16);
    c = 16 * (d % 4);
    g = a.slice(c, c + 16);
    e = parseInt(j[(6 + d) % 16], 16);
    o = parseInt(g[e], 16);
    m = o % 3;
    f = (parseInt(a[e + r], 16) % 4);
    c = 16 * (f % 4);
    n = CryptoJS.SHA256(t).toString(CryptoJS.enc.Hex).slice(c, c + 16);
    s = [ CryptoJS.SHA256, CryptoJS.SHA512, CryptoJS.MD5 ];
    l = b + s[m](a).toString(CryptoJS.enc.Hex) + n
            + s[m](t).toString(CryptoJS.enc.Hex);
    for (q = 0; q < (p > 0 ? p : 1); q++) {
        l = s[m](l).toString(CryptoJS.enc.Hex)
    }
    return t + "::" + a + "::" + l
};

export const encrypt = (text:string) : string => {
    return CryptoJS.SHA256(text)
            .toString(CryptoJS.enc.Hex);
}

export interface CredentialsDigester extends Digester{
    setUserName: ( userName: string ) => void,
    getUserName: ( ) => string,
    setPassword: ( password: string ) => void,
    setCredentials: ( credentials: string ) => void,
    getCredentials: ( ) => string,
    clear: ( credentials?: string ) => void
}

export class SHA256Digester implements CredentialsDigester {
    public ENCRYPTED_PASSWORD:string = "+++encrypted+++";
    private WWWAuthenticate:{
        challengeScheme:string,
        realm:string,
        domain:string,
        nonce:string,
        algorithm:string,
        qop:string
    } = null;
    private credentials: string = null;
    private guestCredentials: string = null;
    private password: string = null;
    private nc: number =0;
    private clientKey: string = '' + new Date().getTime();
    private WWWAuthentication: string = null;

    constructor(private credentialsStorage?: TLMDStorage){
    
    }
    
    clear = (credentials: string) : void  => {
        this.WWWAuthentication = null;
        this.nc = 0;
        this.setCredentials(credentials);
    };
    
    setCredentials = (credentials: string) : void => {
        this.credentials = (credentials ? credentials : this.guestCredentials);
        if( this.credentialsStorage ){
            if (this.credentials && this.credentials.length > 0) {
                this.credentialsStorage.setStorageItem("ucKey", this.credentials);
            } else {
                this.credentialsStorage.clearStorageItem("ucKey");
            }
        }
    };
    
    equalsCredentials = (credentials: string) : boolean => credentials === this.credentials;
    
    reloadCredentials = () : void => {
        let credentials = this.credentialsStorage ? this.credentialsStorage.getStorageItem("ucKey") : undefined;
        this.credentials = credentials && credentials.length > 0 ? credentials : this.guestCredentials; 
    };
    
    getCredentials = ( ) : string => {
        return this.credentials;
    };

    setUserName = (userName: string) : void => {
        if (this.credentials  && this.credentials.indexOf(':') !== -1) {
            this.setCredentials(userName
                    + this.credentials.substring(this.credentials
                            .indexOf(':')));
        } else {
            this.setCredentials(userName + "::");
        }
    };
    
    setPassword = (password: string) : void => {
        if (this.credentials && this.credentials.indexOf(':') !== -1) {
            this.setCredentials(this.credentials.substring(0, this.credentials
                    .indexOf(':'))
                    + "::" + password);
        } else {
            this.setCredentials("::" + password);
        }
    };
    
    getUserName = () : string => {
        return this._extractUserName(this.credentials);
    };
    
    private _extractUserName = (credentials : string) :  string => {
        if (credentials && credentials.indexOf(':') !== -1) {
            return credentials.substring(0, credentials
                    .indexOf(':'));
        } else {
            return undefined;
        }
    };
    
    private _getHA1 = (credentials : string) : string => {
        return CryptoJS.SHA256(
                credentials.replace('::', ':'
                        + this.WWWAuthenticate.realm + ':')).toString(
                CryptoJS.enc.Hex);
    };
    
    private _getHA2 = (method:string, uri:string) : string => {
        var decodedURI = decodeURI(uri);
        return CryptoJS.SHA256(method + ':' + decodedURI).toString(
                CryptoJS.enc.Hex);
    };
    
    private _setWWWAuthenticate = (WWWAuthenticateHeader: string) : boolean  => {
        if (WWWAuthenticateHeader && WWWAuthenticateHeader.length > 0) {
            const firstSpaceIndex = WWWAuthenticateHeader.indexOf(' ');
            if (firstSpaceIndex == -1)
                return null;
            const challengeScheme = WWWAuthenticateHeader.substring(0, firstSpaceIndex);
            if (challengeScheme === 'SHA256Digest'){
                let parsedWWWAuthenticateHeader: any = {
                        challengeScheme : challengeScheme
                };
                const parameters = WWWAuthenticateHeader.substring( firstSpaceIndex).split(',');
                for (let i = 0; i < parameters.length; i++) {
                    const keyValue = parameters[i].split('=');
                    const key = keyValue[0].replace(' ', '');
                    const value = (keyValue[1].charAt(0) == '"' ? keyValue[1]
                    .substring(1, keyValue[1].length - 1) : keyValue[1]);
                    parsedWWWAuthenticateHeader[key] = value;
                }
                this.WWWAuthenticate = parsedWWWAuthenticateHeader;
                return true;
            } else {
                throw new Error( 'Challenge scheme SHA256Digest is supported only.');
            }
        } else {
            // this.WWWAuthenticate=null;
            return false;
        }
    };
    
    private _getNC = () : string => {
        const ncNumber = this.nc;
        var ncStr = ncNumber.toString(16);
        while (ncStr.length < 8)
            ncStr = '0' + ncStr;
        return ncStr;
    };
    
    private _getCNONCE = (): string => {
        var currentTimeMS = '' + new Date().getTime();
        return CryptoJS.SHA256(
                currentTimeMS + ':' + this.nc + ':' + this.clientKey)
                .toString(CryptoJS.enc.Hex);
    };
    
    private _getResponse = (method:string, uri:string, cnonce:string, nc:string, credentials : string) : string => {
        const ha1 = this._getHA1(credentials);
        const decodedUri = decodeURIComponent(uri);
        const ha2 = this._getHA2(method, decodedUri);

        if (this.WWWAuthenticate.qop != null
                && (this.WWWAuthenticate.qop == 'auth' || this.WWWAuthenticate.qop == 'auth-int')) {
            return CryptoJS.SHA256(
                    ha1 + ':' + this.WWWAuthenticate.nonce + ':' + nc + ':'
                            + cnonce + ':' + this.WWWAuthenticate.qop + ':'
                            + ha2).toString(CryptoJS.enc.Hex);
        } else {
            return CryptoJS.SHA256(
                    ha1 + ':' + this.WWWAuthenticate.nonce + ':' + ha2)
                    .toString(CryptoJS.enc.Hex);
        }
    };
    
    private _canAuthorize = (credentials : string) : boolean => {
        return (this.WWWAuthenticate != null && credentials != null
                && credentials.length > 0
                && credentials.indexOf('::') > 0 && credentials
                .indexOf('::') < (credentials.length - 2));
    };
    
    private _setAuthorization (xmlHttpRequest: XMLHttpRequest, method: string, uri: string, credentials : string) : boolean {
        if (this._canAuthorize(credentials)) {
            this.nc++;
            const cnonce = this._getCNONCE();
            const nc = this._getNC();
            const response = this._getResponse(method, uri, cnonce, nc, credentials);
            var authorization = this.WWWAuthenticate.challengeScheme
                    + ' username="' + this._extractUserName( credentials ) + '", realm="'
                    + this.WWWAuthenticate.realm + '", nonce="'
                    + this.WWWAuthenticate.nonce + '", uri="' + uri
                    + '", algorithm=' + this.WWWAuthenticate.algorithm
                    + ', response="' + response + '", qop='
                    + this.WWWAuthenticate.qop + ', nc=' + nc
                    + ', cnonce="' + cnonce + '"';
            xmlHttpRequest.setRequestHeader('Authorization', authorization);
            return true;
        } else {
            return false;
        }
    };
    
    public onAuthenticate = ( WWWAuthenticateHeader: string ) : boolean => {
      return this._setWWWAuthenticate(WWWAuthenticateHeader); 
    };
    
    public setAuthorization = ( xhr:XMLHttpRequest, options:XHROptions ) : void => {
      this._setAuthorization( xhr, options.method, options.url, options.credentials ? options.credentials : this.credentials );  
    };
   
}
